export default "__VITE_ASSET__Cy6AZD6y__"